export class StatisticFilterModel {
    public BeginRegDate: Date;
    public EndRegDate: Date;
    public domainId: number;
    public browser: string;
    public os: string;
    public country: string;
    public device: number;
    public groupBy: number;
    public groupByTokenName: string;
    public statsType: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/statisticFilter.model.ts